import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import "./style.scss";
import Question from "../../containers/question/";
import {
  dataToJS,
  isLoaded,
  pathToJS,
  firebaseConnect
} from "react-redux-firebase";
import BlankPage from "../blank/";
import DrawerToggle from "../../containers/drawer-toggle/";
class ViewStudentLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null
    };
  }

  componentWillMount() {
    this.props.firebase.set(
      `/responses/groups/${this.props.match.params.logId}/logs/${this.props.match.params.logId}/students/${this.props.auth.uid}/set`,
      true
    );
  }

  componentWillUnmount() {}

  componentWillReceiveProps(props) {
    this.setState({ responses: this.props.responses });
  }

  updateQuestion({ value, groupId, questionId }) {
    this.props.firebase.set(
      `/responses/groups/${this.props.match.params.logId}/logs/${this.props.match.params.logId}/students/${this.props.auth.uid}/group/${groupId}/question/${questionId}`,
      value
    );

    this.updatePercentage();
  }

  updatePercentage() {
    let complete = 0;
    let total = 0;

    if (this.props.log && this.props.responses && this.props.auth) {
      this.props.log.groups.map((group, groupIndex) => {
        group.questions.map((question, questionIndex) => {
          if (
            this.props.responses &&
            this.props.responses.group[groupIndex] &&
            this.props.responses.group[groupIndex].question[questionIndex] &&
            (this.props.responses.group[groupIndex].question[
              questionIndex
            ].value ||
              this.props.responses.group[groupIndex].question[
                questionIndex
              ].reason)
          ) {
            complete++;
          }
          total++;
        });
      });

      console.log(complete / total);
      this.props.firebase.set(
        `/percentage/groups/${this.props.match.params.groupId}/users/${this.props.auth.uid}/logs/${this.props.match.params.logId}`,
        {
          complete: complete,
          total: total,
          value: complete / total,
          createdAt: Date()
        }
      );
    }
  }

  render() {
    if (isLoaded(this.props.log) && isLoaded(this.props.responses)) {
      return (
        <div className="flex-container">
          <div className="toolbar">
            <DrawerToggle /> <h1>{this.props.log.title}</h1>
          </div>
          <div className="content log">
            <div className="page">
              <div className="max-width">
                {this.props.log.directions &&
                  <div
                    className=""
                    dangerouslySetInnerHTML={{
                      __html: this.props.log.directions
                    }}
                  />}
                {this.props.log.groups.map(
                  (group, groupId) =>
                    group &&
                    <div
                      key={
                        `${this.props.match.params.groupId}${this.props.match.params.logId}${groupId}`
                      }
                    >
                      <h1>{group.title}</h1>
                      <div className="card">
                        {(group.questions || []).map((question, questionId) => (
                          <Question
                            key={
                              `${this.props.match.params.groupId}${this.props.match.params.logId}${groupId}${questionId}`
                            }
                            disabled={true}
                            question={question}
                            value={
                              this.props.responses &&
                                this.props.responses.group &&
                                this.props.responses.group[groupId]
                                ? this.props.responses.group[groupId].question[
                                    questionId
                                  ]
                                : null
                            }
                            responses={
                              this.props.responses &&
                                this.props.responses.group &&
                                this.props.responses.group[groupId]
                                ? this.props.responses.group[groupId].question[
                                    questionId
                                  ]
                                : null
                            }
                            log={this.props.log}
                            onChange={(value => {
                              this.updateQuestion({
                                groupId: groupId,
                                questionId: questionId,
                                value: value
                              });
                            }).bind(this)}
                          />
                        ))}
                      </div>
                    </div>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return <BlankPage />;
    }
  }
}

export default withRouter(
  connect(({ firebase }, { match, auth }) => {
    if (auth)
      return {
        groups: dataToJS(firebase, "/groups"),
        responses: dataToJS(
          firebase,
          `/responses/groups/${match.params.groupId}/logs/${match.params.logId}/students/${match.params.studentId}`
        ),
        log: dataToJS(firebase, `/logs/${match.params.logId}`)
      };
    return null;
  })(
    firebaseConnect(({ match, auth }) => {
      return auth
        ? [
            "/logs",
            "/groups",
            `/responses/groups/${match.params.groupId}/logs/${match.params.logId}/students/${match.params.studentId}`
          ]
        : [];
    })(ViewStudentLog)
  )
);



// WEBPACK FOOTER //
// ./src/routes/view-student-log/index.js